import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=0322914a&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "spinner.vue"
export default component.exports